import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import { toStatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'

export class ReportingMathsDashboardRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const product: LegacyProductMs = 'maths'
    const statsScope = toStatsScope(uiScope)

    const stats = await this.makeStatsRequest(product, statsScope, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductMs, scope: StatsScope, period: NormalizedInterval) => {
    const { studentEvents } = this

    return RSVP.hash({
      totalUsageOverTime: studentEvents.totalUsageOverTime(product, scope, period),
      courseProgressByGrade: studentEvents.courseProgressByGrade(product, 'lessons', scope, period),
      workingAtGradeLevel: studentEvents.workingAtGradeLevel(product, scope, period),
      drivingTests: studentEvents.drivingTests(product, scope, period),
      mentalMinuteSummary: studentEvents.mentalMinuteSummary(product, scope, period),
      awardsEarned: studentEvents.awardsEarned(product, scope, period),
      skillsMastered: studentEvents.skillsMasteredMs(product, scope, period),
    })
  }
}
export default ReportingMathsDashboardRoute
